<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm"></Toolbar>
    <CategoriePartenaireForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import CategoriePartenaireForm from '../../components/categoriepartenaire/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'CategoriePartenaire';

const { mapFields } = createHelpers({
  getterType: 'categoriepartenaire/getField',
  mutationType: 'categoriepartenaire/updateField'
});

export default {
  name: 'CategoriePartenaireCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    CategoriePartenaireForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('categoriepartenaire', ['create', 'reset'])
  }
};
</script>
